import React from 'react';
import { Button } from 'reactstrap';

interface MfaQrCodeProps {
  qrCode: string;
  secret: string;
  onNext: () => void;
}

const MfaQrCode = ({ qrCode, secret, onNext }: MfaQrCodeProps) => {
  return (
    <div className="modal-body text-center">
      <h5 className="mb-4">Step 1: Scan QR Code</h5>

      <div className="mb-4">
        <p className="text-muted">Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.)</p>

        <div className="d-flex justify-content-center mb-3">
          <img
            src={qrCode}
            alt="TOTP QR Code"
            className="rounded border"
            style={{ maxWidth: '200px', maxHeight: '200px' }}
          />
        </div>
      </div>

      <div className="mb-4">
        <p className="text-muted small">Can't scan? Enter this code manually in your authenticator app:</p>
        <div className="alert alert-light">
          <code className="user-select-all">{secret}</code>
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <Button color="primary" onClick={onNext}>
          Next: Verify Code
        </Button>
      </div>
    </div>
  );
};

export default MfaQrCode;
